import { ClientContext } from '../../context/IContextService';
import CommandViewModel, { CommandListEntryType } from '../CommandViewModel';
import CategoryCommand from '../wrap/CategoryCommand';

import CommandComponent from './CommandComponent';

class CommandItem<T> implements CommandComponent {
  constructor(private command: CategoryCommand<T>) {}

  public async serialize(context: ClientContext): Promise<CommandViewModel> {
    const badge = this.command.getBadge(context);
    const hotKey = this.command.getHotKey();
    return {
      available: this.command.isAvailable(context),
      ...(!!badge && { badge }),
      caption: await this.command.getCaption(),
      ...(!!hotKey && { hotKey }),
      icon: this.command.getIcon(),
      menuLabel: this.command.getMenuLabel(),
      name: this.command.getName(),
      type: CommandListEntryType.COMMAND,
    };
  }

  public find(name: string): void | CommandComponent {
    if (this.command.getName() === name) {
      return this;
    }
    return undefined;
  }

  public getCommand(): CategoryCommand<T> {
    return this.command;
  }
}

export default CommandItem;
